import TimelineVideo from "../../../../timeline/TimelineVideo/TimelineVideo";

const VideoPreview = require('../../../../../assets/img/timeline/modal/2017-Expert.jpg');

const ExpertContent = () => {
    return (
        <>
            <TimelineVideo videoId="C5r9bJbr1Mc" imagePreview={VideoPreview} />
            <h4>
                The EXPERT clinical trial commences
            </h4>
            <p>
                The EXPERT clinical trial commences, which is the first trial developed by Breast Cancer Trials that we will be coordinating internationally. The primary aim of the trial is to see whether a genomic test of breast cancer tissue can be used to identify women who can safely avoid radiation therapy after breast cancer surgery. Professor Boon Chua is the Study Chair of EXPERT.
            </p>
        </>
    );
}

export default ExpertContent;